import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import {
  CellSelectionModule,
  ClipboardModule,
  ColumnMenuModule,
  ColumnsToolPanelModule,
  ContextMenuModule,
  ExcelExportModule,
  GroupFilterModule,
  IntegratedChartsModule,
  MasterDetailModule,
  MultiFilterModule,
  NewFiltersToolPanelModule,
  PivotModule,
  RichSelectModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  SideBarModule,
  StatusBarModule,
  TreeDataModule
} from 'ag-grid-enterprise';
import { AgChartsCommunityModule } from 'ag-charts-community';

export const registerAgGridModules = () => {
  provideGlobalGridOptions({ theme: 'legacy', suppressOverlays: ['noMatchingRows'] });
  ModuleRegistry.registerModules([
    AllCommunityModule,
    ColumnsToolPanelModule,
    IntegratedChartsModule.with(AgChartsCommunityModule),
    ExcelExportModule,
    NewFiltersToolPanelModule,
    MasterDetailModule,
    CellSelectionModule,
    RichSelectModule,
    RowGroupingModule,
    TreeDataModule,
    PivotModule,
    RowGroupingPanelModule,
    GroupFilterModule,
    SideBarModule,
    StatusBarModule,
    SetFilterModule,
    ColumnMenuModule,
    ContextMenuModule,
    ClipboardModule,
    MultiFilterModule
  ]);
};
